import { Line } from './BaseChart'
import { reactiveProp } from '@/mixins/chart'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import ChartJsPluginStreaming from 'chartjs-plugin-streaming'

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 190
    },
    classCanvas: {
      type: String,
      default: 'w-full'
    }
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.addPlugin(ChartJsPluginDataLabels)
    this.addPlugin(ChartJsPluginStreaming)

    this.onAnimationCompleteOptionsAppend()

    this.renderChart(
      this.chartData,
      this.options,
      this.height,
      this.classCanvas
    )
  },
  methods: {
    onAnimationCompleteOptionsAppend() {
      var _this = this
      this.options.animation = {
        onComplete: function () {
          _this.$emit('rawChart', _this.getBase64())
        }
      }
    },
    getBase64() {
      return this.$refs.canvas.toDataURL('image/png')
    }
  }
}
